export default __webpack_public_path__ + "static/media/hall_of_fame_header.25126932.png";